import { useIntl } from 'react-intl';

const useDateUtils = () => {
  const { locale } = useIntl();

  const toLongDate = (date: Date) => {
    return new Intl.DateTimeFormat(locale, { dateStyle: 'long' })
      .format(date)
      .toString();
  };

  const isDDMMYYYYFormat = (date: string) => {
    const regex =
      /(((0|1)[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/((19|20)\d\d))$/;

    return regex.test(date);
  };

  return {
    toLongDate,
    isDDMMYYYYFormat,
  };
};

export default useDateUtils;
